import { useEffect, useState } from "react";
import { Link, useNavigate, useParams } from "react-router-dom";
import { API_URL } from "../../shared/constant";
import { toast } from "react-toastify";
import { Watch } from "react-loader-spinner";
import axios from "axios";

const Add = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const [isError, setError] = useState(false);
  const [loading, setLoading] = useState(false);
  const [formData, setFormData] = useState({
    id: null,
    title: "",
    file: "",
    image: null,
    image_url: "",
    video: null,
    video_url: "",
  });

  const onSave = () => {
    if (isValidForm()) {
      setError(false);
      setLoading(true);
      const prodFormData = new FormData();
      prodFormData.append("title", formData.title);
      if (formData.image) {
        prodFormData.append("image", formData.image);
      }
      if (formData.video) {
        prodFormData.append("video", formData.video);
      }
      if (id) {
        prodFormData.append("id", id);
      }
      const pUrl = id ? API_URL.POST_UPDATE : API_URL.POST_SAVE;
      axios
        .post(pUrl, prodFormData)
        .then((res) => {
          if (res.data.status === 1) {
            let message = id
              ? "Posts Updated Successfully."
              : "Posts Created Successfully.";
            toast.success(message, { autoClose: 3000, position: "top-right" });
            setLoading(false);
            navigate("/admin/posts");
          }
        })
        .catch((error) => {
          setLoading(false);
          setError(true);
        })
        .finally(() => {
          setLoading(false);
          setError(true);
        });
    } else {
      setLoading(false);
      setError(true);
    }
  };

  const onEdit = () => {
    axios.post(API_URL.POST_GET, { id: id }).then((res) => {
      if (res.data.status === 1) {
        setFormData({
          id: res.data.data.id,
          title: res.data.data.title ? res.data.data.title : "",
          file: res.data.data.file ? res.data.data.file : "",
          image_url: res.data.data.image ? res.data.data.image : "",
          video_url: res.data.data.video ? res.data.data.video : "",
        });
      }
    });
  };

  const isValidForm = () => {
    if (!formData.title) return false;
    if (!id && !(formData.image || formData.video)) return false;
    return true;
  };

  const isRequiredField = (key) => {
    return isError && !formData[key];
  };

  useEffect(() => {
    id && onEdit();
  }, [id]);

  return (
    <>
      <div className="page-header">
        <div className="content-page-header">
          <h5>{id ? "Update" : "Add"} Posts</h5>
        </div>
      </div>
      <div className="card">
        <div className="card-body">
          <form>
            <div className="row">
              <div className="col-lg-4 col-md-4 col-sm-12">
                <div className="form-group">
                  <label>
                    Name<span className="required-star">*</span>
                  </label>
                  <input
                    type="text"
                    name="title"
                    value={formData.title}
                    className={
                      isRequiredField("title")
                        ? "form-control required"
                        : "form-control"
                    }
                    id="title"
                    onChange={(event) => {
                      setFormData({ ...formData, title: event.target.value });
                    }}
                  />
                </div>
              </div>
              <div className="col-lg-4 col-md-4 col-sm-12">
                <div className="row">
                  <div className="col-md-12">
                    <div className="form-group">
                      <label>
                        Image
                       {!formData.video && <span className="required-star">*</span>}
                      </label>
                      <input
                        accept="image/*"
                        type="file"
                        name="image"
                        className={
                          (isRequiredField("image") && !formData.video)
                            ? "form-control required"
                            : "form-control"
                        }
                        disabled={formData.video}
                        onChange={(e) => {
                          const file = e.target.files[0];
                          setFormData({
                            ...formData,
                            image: file,
                            video: null,
                          });
                        }}
                      />
                    </div>
                  </div>
                  {formData.image_url && (
                    <div className="col-md-12">
                      <div>
                        <a
                          href={formData.image_url}
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          <img
                            src={formData.image_url}
                            height={100}
                            width={100}
                            alt="post_image"
                          />
                        </a>
                      </div>
                    </div>
                  )}
                </div>
              </div>
              <div className="col-lg-4 col-md-4 col-sm-12">
                <div className="row">
                  <div className="col-md-12">
                    <div className="form-group">
                      <label>
                        Video
                        {!formData.image && <span className="required-star">*</span>}
                      </label>
                      <input
                        accept="video/*"
                        type="file"
                        name="video"
                        className={
                          (isRequiredField("video") && !formData.image)
                            ? "form-control required"
                            : "form-control"
                        }
                        disabled={formData.image}
                        onChange={(e) => {
                          const file = e.target.files[0];
                          setFormData({
                            ...formData,
                            video: file,
                            image: null,
                          });
                        }}
                      />
                    </div>
                  </div>
                  {id && formData.video_url && (
                    <div className="col-md-12 mt-2">
                      <div>
                        <video width="150" height="150" controls>
                          <source src={formData.video_url} type="video/mp4" />
                          Your browser does not support the video tag.
                        </video>
                      </div>
                    </div>
                  )}
                </div>
              </div>
              <div className="col-lg-12 col-md-12 col-sm-12 mt-3">
                <div className="text-end">
                  <Link
                    to={"/admin/posts"}
                    className={
                      loading
                        ? "btn btn-danger btn-sm me-2 disabled-link"
                        : "btn btn-danger btn-sm me-2"
                    }
                    onClick={(e) => loading && e.preventDefault()}
                  >
                    Cancel
                  </Link>
                  <button
                    type="button"
                    onClick={onSave}
                    disabled={loading}
                    className="btn btn-primary btn-sm"
                  >
                    <div className="d-flex justify-content-center align-items-center gap-2">
                      {loading && (
                        <Watch color={"white"} height={15} width={15} />
                      )}
                      Submit
                    </div>
                  </button>
                </div>
              </div>
            </div>
          </form>
        </div>
      </div>
    </>
  );
};

export default Add;
